import React from 'react'

import { useIntl } from 'react-intl'

import EmptyStateImage from 'app/assets/images/reviews/reviews-empty.svg'
import EmptyState from 'app/components/common/EmptyState'

const ReviewsEmptyState: RFC = () => {
  const intl = useIntl()

  return (
    <EmptyState
      image={<EmptyStateImage />}
      text={intl.formatMessage({
        defaultMessage: 'There are no reviews yet'
      })}
      hideButton
    />
  )
}

export default ReviewsEmptyState
